import { type MCPServerInfo } from '../../types';

const GenaiToolboxServer: MCPServerInfo = {
  serverId: 'GENAI_TOOLBOX',
  name: 'Genai Toolbox for Databases',
  slug: 'genai-toolbox',
  description:
    "Google's MCP Toolbox for Databases — connect to BigQuery, PostgreSQL, MySQL, Spanner, AlloyDB, Snowflake, Neo4j, Elasticsearch, and 30+ other data sources using the Model Context Protocol.",
  source: {
    sourceType: 'LOCAL_PACKAGE',
    transport: 'STDIO',
    commandFunction: `(config) => ({
  command: 'toolbox',
  args: ['--prebuilt', config.prebuilt, '--stdio'],
  env: {}
})`
  },
  authenticationType: 'NONE',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['prebuilt'],
    properties: {
      prebuilt: {
        type: 'string',
        description:
          'Prebuilt data source to connect to (e.g. bigquery, postgres, mysql, spanner, snowflake, neo4j). See https://github.com/googleapis/genai-toolbox for the full list of supported sources. Connection credentials must be set as environment variables.',
        sensitive: false
      }
    }
  }
};

export default GenaiToolboxServer;
